import React from 'react'
import Controls from './controls'

const Default = (props) => {
	return (
		<React.Fragment>
			<Controls />
			<div id="video-player"></div>
		</React.Fragment>
	)
}

export default Default


// WEBPACK FOOTER //
// ./src/desktop/components/video-player/default.js